import React, { useState, useEffect } from "react";
import AuthService from "services/auth.service";
import SmsReminderService from "services/sms-reminder.service";
import { CreateModal } from "./CreateModal";
import { EditModal } from "./EditModal";
import RemoveBtn from "assets/icons/Remove.svg";
import InfoIcon from "assets/icons/info-icon.svg";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";

import moment from "moment";

export function SmsReminder() {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [currentUsage, setCurrentUsage] = useState(0);
  const [balance, setBalance] = useState(0);
  const [pendingUsage, setPendingUsage] = useState(0);
  const [smsHeader, setSmsHeader] = useState("");

  useEffect(() => {
    setLoading(true);
    const parameters = {};

    SmsReminderService.getSmsReminderAllocation(parameters).then(
      (data) => {
        setCurrentUsage(data.doctor_sms_allocation.current_usage);
        setPendingUsage(data.doctor_sms_allocation.pending_usage);
        setBalance(data.doctor_sms_allocation.balance);
        setSmsHeader(`${data.doctor_sms_allocation.sms_header}: `);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );

    SmsReminderService.listSmsReminders(parameters)
      .then(
        (data) => {
          setRecords(data.doctor_sms_reminders);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        }
      )
      .then(() => {
        setLoading(false);
      });
  }, []);

  const Records = () => {
    if (loading)
      return (
        <tr className="loader">
          <td className="border-bottom-0">
            <Spinner animation="border" className="spinner" />
          </td>
        </tr>
      );
    if (records.length === 0)
      return (
        <tr className="loader">
          <td className="border-bottom-0">No Sms Reminder Available</td>
        </tr>
      );

    return records.map((n, i) => {
      return (
        <tr key={`sms-reminder-row-${i}`} className="sms-reminder-row bg-white">
          {/* Desktop View */}
          <td className="d-none d-lg-table-cell py-6 pl-6">
            <div className="font-size-6 fweight-400">{n.days_before}</div>
          </td>
          <td className="d-none d-lg-table-cell py-6 pr-4">
            <div className="datetime fweight-400">
              {moment.utc(n.time * 1000).format("HH:mm")}
            </div>
          </td>

          <td className="d-none d-lg-table-cell py-6 pr-4 w-40">
            <div className="font-size-6 fweight-400">{n.body}</div>
          </td>

          <td className="d-none d-lg-table-cell py-6 pr-2">
            <div className="font-size-6 fweight-400">
              {n.is_enabled === true ? (
                <div>
                  <span className="badge-success badge-pill">Enable</span>
                </div>
              ) : (
                <span className="badge-danger badge-pill">Disable</span>
              )}
            </div>
          </td>
          <td className="d-none d-lg-table-cell details pr-5">
            <div className="datetime font-size-6 fweight-400">
              {moment(n.created_at).format("DD MMM YYYY, HH:mm A")}
            </div>
          </td>

          <td className="d-none d-lg-table-cell pr-2">
            <div className="row">
              <EditModal data={n} sms_header={smsHeader} />
              <img
                src={RemoveBtn}
                alt="remove"
                className="clickable"
                onClick={() => confirmDelete(n.id)}
              />
            </div>
          </td>

          {/* Mobile View */}
          <td
            colSpan="6"
            valign="top"
            className={
              "d-table-cell d-lg-none font-size-7 py-6 pl-6 border-black"
            }
          >
            <div className="d-lg-none font-size-7 py-6 pl-6 pr-6">
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Days Before Appointment:
                </span>
                <b>{n.days_before}</b>
                <div
                  valign="top"
                  className="d-flex justify-content-between mt-2 mb-2 float-right"
                >
                  <div className="mb-0 flex-grow-1">
                    <b className="d-inline-block font-size-6">
                      <EditModal data={n} />
                    </b>
                  </div>
                  <img
                    src={RemoveBtn}
                    alt="remove"
                    className="px-2 clickable"
                    onClick={() => confirmDelete(n.id)}
                  />
                </div>
              </div>
              <br />
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Time:
                </span>
                <b>{n.time}</b>
              </div>
              <br />
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Status:
                </span>
                <b>
                  {n.is_enabled === true ? (
                    <span className="badge-success badge-pill">Enable</span>
                  ) : (
                    <span className="badge-danger badge-pill">Disable</span>
                  )}
                </b>
              </div>
              <br />
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Created At:
                </span>
                <b>{moment(n.created_at).format("DD MMM YYYY, HH:mm A")}</b>
              </div>
              <br />
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Message Body:
                </span>
                <b>{n.body}</b>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  };

  const EmptyRow = () => {
    return (
      <tr className="position-relative">
        <td
          colSpan="5"
          className="text-center font-size-7 fweight-500 py-4"
          style={{ borderRadius: "0.5em" }}
        >
          No sms reminder available
        </td>
      </tr>
    );
  };

  const confirmDelete = (target) => {
    const confirmed = window.confirm(
      "You are about to delete this sms reminder. Confirm?"
    );

    if (confirmed) {
      const parameters = {};

      SmsReminderService.deleteSmsReminder(target, parameters).then(
        () => {
          window.location.reload();
          alert("Sms reminder has been deleted.");
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        }
      );
    }
  };

  return (
    <div id="main-content-target" className="sms-reminder-page">
      <CreateModal
        sms_header={smsHeader}
        handleReload={() => this.refreshEverything()}
      />

      <h1 className="text-danger">Sms Reminder</h1>

      <div className="d-flex flex-wrap my-6 font-size-3">
        <div
          className="dashboard-stats-box text-center shadow-sm mr-2 mb-2"
          style={{ backgroundColor: "#FEF4E6" }}
        >
          <p className="text-grey fweight-500 font-size-20 my-4">
            {currentUsage}
          </p>
          <h5 className="mb-6">Total SMS Sent</h5>
        </div>

        <div
          className="dashboard-stats-box text-center shadow-sm mr-2 mb-2"
          style={{ backgroundColor: "#F6FDF6" }}
        >
          <p className="text-grey fweight-500 font-size-20 my-4">
            {pendingUsage}
          </p>
          <h5 className="mb-6">Pending SMS</h5>
        </div>

        <div
          className="dashboard-stats-box text-center shadow-sm mr-2 mb-2"
          style={{ backgroundColor: "#F3F6FF" }}
        >
          <p className="text-grey fweight-500 font-size-20 my-4">{balance}</p>
          <h5 className="mb-6">Balance SMS</h5>
        </div>
        <div
          className="font-size-12 dashboard-notice-box shadow mr-2 mb-2"
          style={{ backgroundColor: "#FFF6F3", color: "#FF725E" }}
        >
          <Alert className="d-flex align-items-center">
            <img src={InfoIcon} alt="info-icon" className="px-2" />
            <div>
              <b> Note: </b>The new message content will only be updated after
              12am
            </div>
          </Alert>
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center my-12">
          <Spinner animation="border" className="spinner" />
        </div>
      ) : (
        <table id="sms-reminder-table" className="w-100">
          <thead className="d-none d-lg-table-header-group">
            <tr>
              {[
                "Days Before Appointment",
                "Time",
                "Message Body",
                "Status",
                "Created At",
                "Action",
              ].map((name) => {
                return (
                  <th
                    key={"table-header-" + name}
                    className={
                      "d-none d-lg-table-cell font-size-7 fweight-500 position-relative pr-4"
                    }
                  >
                    {name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>{records.length === 0 ? <EmptyRow /> : <Records />}</tbody>
        </table>
      )}
    </div>
  );
}

export default SmsReminder;
